import {Box, Link, Typography} from '@mui/material'
import {memo} from 'react'
import {Link as RouterLink} from 'react-router'
import {useSpotHelperGetCurrent} from '../../../../hooks/entity/useSpot'
import {useSpotPath} from '../../../../hooks/useSpotNavigate'
import {AppLogo} from './AppLogo'
import {VisitStarButton} from './VisitStarButton'

export const AppBarSpot = memo(() => {
  const spotPath = useSpotPath()
  const {spot} = useSpotHelperGetCurrent()

  return <Link
    component={RouterLink}
    to={spotPath ?? '/'}
    underline="none"
    className="ellipsis-container"
    sx={{color: 'inherit'}}
  >
    <Typography
      variant="h6"
      component="div"
      className="ellipsis-container"
      sx={{
        display: 'flex',
        gap: 1,
        alignItems: 'center',
      }}
    >
      <Box sx={{display: {xs: 'none', sm: 'inherit'}}}>
        <AppLogo/>
      </Box>
      <div className="ellipsis">{spot ? spot.name : 'VerticalTopo'}</div>
      {spot && <VisitStarButton spot={spot} showAdmin={false}/>}
    </Typography>
  </Link>
})
